import { getApiBaseUrl } from './config_utils';

export const SITE_NAME = '山间码坊';
export const SITE_URL = 'https://shanjiancode.com';

export function currentCanonical(pathname = window.location.pathname) {
  if (typeof window === 'undefined') return `${SITE_URL}${pathname}`;
  return `${window.location.origin}${pathname}`;
}

export function setMeta(name: string, content: string, attr: 'name' | 'property' = 'name') {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.content = content;
}

export function setPageMeta({ title, description, keywords }: {
  title: string;
  description: string;
  keywords?: string[];
}) {
  document.title = title.includes(SITE_NAME) ? title : `${title} - ${SITE_NAME}`;
  setMeta('description', description);
  if (keywords?.length) setMeta('keywords', keywords.join(','));
  setMeta('og:title', document.title, 'property');
  setMeta('og:description', description, 'property');
  setMeta('og:type', 'website', 'property');
}

export function setJsonLd(id: string, data: unknown) {
  let el = document.getElementById(id) as HTMLScriptElement | null;
  if (!el) {
    el = document.createElement('script');
    el.id = id;
    el.type = 'application/ld+json';
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
}

export function removeJsonLd(id: string) {
  document.getElementById(id)?.remove();
}

export function organizationJsonLd() {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: SITE_NAME,
    url: SITE_URL,
    logo: `${SITE_URL}/images/favicon.svg`,
    sameAs: [],
    description: '山间码坊提供 AI Agent、AI 自动化、软件开发、招聘信息监控和小程序内容运营服务。'
  };
}

export function websiteJsonLd() {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: SITE_NAME,
    url: SITE_URL,
    potentialAction: {
      '@type': 'SearchAction',
      target: `${SITE_URL}/news?q={search_term_string}`,
      'query-input': 'required name=search_term_string'
    }
  };
}

export function breadcrumbJsonLd(items: Array<{ name: string; url: string }>) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: item.url
    }))
  };
}

export function trackVisit(pathname: string, title: string) {
  const payload = JSON.stringify({
    path: pathname,
    pageTitle: title,
    referrer: document.referrer || '',
    source: 'website'
  });
  const url = `${getApiBaseUrl()}/api/v1/analytics/visit`;
  if (navigator.sendBeacon) {
    const blob = new Blob([payload], { type: 'application/json' });
    navigator.sendBeacon(url, blob);
    return;
  }
  fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: payload,
    keepalive: true
  }).catch(() => undefined);
}
